<template>
  <Tabs>
    <TabPane label="注册用户" icon="ios-person-add">
      <signup-mumber @refresh="refresh"></signup-mumber>
    </TabPane>
    <TabPane label="直接添加" icon="ios-add-circle">
      <plus-mumber @refresh="refresh"></plus-mumber>
    </TabPane>
  </Tabs>
</template>

<script>
import PlusMumber from '@/components/team/PlusMumber'
import SignupMumber from '@/components/team/SignupMumber'

export default {
  name: 'add-mumber',
  data: function () {
    return {
    }
  },
  components: {
    'plus-mumber': PlusMumber,
    'signup-mumber': SignupMumber
  },
  methods: {
    refresh: function () {
      this.$emit('refresh')
    }
  }
}
</script>
